import React, { useEffect, createElement } from 'react';
export function WistiaVideo() {
  useEffect(() => {
    // Load Wistia player script
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.body.appendChild(playerScript);
    // Load Wistia embed script
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/bwlmzt9mmc.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.body.appendChild(embedScript);
    // Add styles
    const style = document.createElement('style');
    style.textContent = `
      wistia-player[media-id='bwlmzt9mmc']:not(:defined) { 
        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/bwlmzt9mmc/swatch'); 
        display: block; 
        filter: blur(5px); 
        padding-top: 56.25%; 
      }
    `;
    document.head.appendChild(style);
    return () => {
      // Cleanup scripts and styles on unmount
      if (playerScript.parentNode) {
        playerScript.parentNode.removeChild(playerScript);
      }
      if (embedScript.parentNode) {
        embedScript.parentNode.removeChild(embedScript);
      }
      if (style.parentNode) {
        style.parentNode.removeChild(style);
      }
    };
  }, []);
  return <div className="w-full" data-id="element-232">
      <wistia-player media-id="bwlmzt9mmc" aspect="1.7777777777777777" data-id="element-233" />
    </div>;
}